import * as React from 'react';
import './style.scss';
import { WizardStepState } from './models/wizard-step-state.enum';

function WizardStep({ id, number, heading, state, className, children }: { id: string; number: number; heading: string; state: WizardStepState; className: string; children?: React.ReactNode }) {
  return (
    <div id={id} className={`wizard-step fullwidth-xs ${className} wizard-step--${WizardStepState[state]}`}>
      <div className={`wizard-step-heading wizard-step-heading--${WizardStepState[state]}`}>
        <h2 className="h3 mb-0 p-3 d-flex align-items-center">
          <span className="wizard-step-heading__numeral rounded-circle text-center me-2 align-items-center justify-content-center">{number}</span>
          <span className="wizard-step-heading__checkmark rounded-circle text-center me-2"></span>
          <span>{heading}</span>
        </h2>
      </div>
      {children}
    </div>
  );
}

export default WizardStep;
